<template>
    <div class="card">
        <div class="card-header">Projet</div>
        <div class="card-body">
            <div>
                <!-- Mode lecture seule - Affichage du projet sélectionné -->
                <div v-if="readonly && hasProject" class="d-flex justify-content-center px-2">
                    <span class="text-muted mr-1">
                        {{ getProjectFlag(campaign.project.project_lang) }}
                        {{ campaign.project.name }}
                    </span>
                    <span class="ml-auto text-truncate"> {{ campaign.project.budget }} € </span>
                </div>

                <!-- Mode lecture seule - Aucun projet sélectionné -->
                <div v-else-if="readonly && !hasProject" class="d-flex justify-content-center px-2">
                    <span class="text-muted">Aucun projet sélectionné</span>
                </div>

                <!-- Mode édition - Sélecteur de projet -->
                <select v-else class="form-control" @change="updateProject($event)">
                    <option disabled :value="null" :selected="!hasProject">-</option>
                    <option
                        v-for="project in availableProjects"
                        :key="project.id"
                        :value="project.id"
                        :selected="hasProject && project.id === campaign.project.id"
                    >
                        {{ getProjectFlag(project.project_lang) }}
                        {{ project.name }}
                        ({{ project.budget }} €)
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        props: {
            campaign: {
                required: true,
                type: Object
            },
            readonly: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            hasProject() {
                return this.campaign?.project && typeof this.campaign.project === 'object';
            },
            availableProjects() {
                return this.campaign?.meta?.projects || [];
            }
        },
        methods: {
            ...mapActions('campaigns', ['updateCampaign']),

            getProjectFlag(projectLang) {
                return projectLang === 'en' ? '🇬🇧' : '🇫🇷';
            },

            updateProject(e) {
                const projectId = e.target.value;
                if (projectId && this.campaign?.id) {
                    this.updateCampaign({
                        campaignId: this.campaign.id,
                        project_id: projectId
                    });
                }
            }
        }
    }
</script>

<style scoped></style>